import { DateTime } from 'luxon';

import { DASH } from '@/globals';

interface IAvailsImportAPI {
  importedavailsfile_id: number;
  file_name: string;
  min_local_date: string;
  max_local_date: string;
  url: string;
  screen_count: number;
  archived: boolean;
  status: string;
  status_message: string;
  modified_on_utc: string;
}

export default class AvailsImport {
  id: number;

  filename: string;

  minLocalDate: string;

  maxLocalDate: string;

  url: string;

  screenCount: number;

  isArchived: boolean;

  status: string;

  statusMessage: string;

  modifiedOnUtc: DateTime | null;

  constructor(
    id = -1,
    filename: string,
    minLocalDate: string,
    maxLocalDate: string,
    url: string,
    screenCount: number,
    isArchived: boolean,
    status: string,
    statusMessage: string,
    modifiedOnUtc?: DateTime,
  ) {
    this.id = id;
    this.filename = filename;
    this.minLocalDate = minLocalDate;
    this.maxLocalDate = maxLocalDate;
    this.url = url;
    this.screenCount = screenCount;
    this.isArchived = isArchived;
    this.status = status;
    this.statusMessage = statusMessage;
    this.modifiedOnUtc = modifiedOnUtc;
  }

  static fromApi(apiObject: IAvailsImportAPI): AvailsImport {
    return new AvailsImport(
      apiObject.importedavailsfile_id,
      apiObject.file_name,
      apiObject.min_local_date,
      apiObject.max_local_date,
      apiObject.url,
      apiObject.screen_count,
      apiObject.archived,
      apiObject.status,
      apiObject.status_message,
      apiObject.modified_on_utc != null ? DateTime.fromISO(apiObject.modified_on_utc, { zone: 'utc' }) : null,
    );
  }

  get modifiedOnFormatted(): string {
    return this.modifiedOnUtc != null ? this.modifiedOnUtc.toLocal().toLocaleString(DateTime.DATETIME_MED) : DASH;
  }
}
